import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';
import { RolesService } from '@pg-app/core/services/roles/role.servirce';
import { from, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RoleGuard implements CanActivate {
  constructor(private rolesService: RolesService, private router: Router) { }
  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    const expectedRole = route.data.expectedRole;
    let userRoles;
    const expectRole = new Promise(resolve => {
      this.rolesService.getRoles(expectedRole).then(data => {
        userRoles = data;
        if (!userRoles) {
          const redirectUrl = route.data.redirectUrl;
          if (redirectUrl) {
            this.router.navigate([redirectUrl]);
          }
          resolve(false);
        }
        resolve(true);
      });
    });
    return from(expectRole) as Observable<boolean>;
  }
}


